import React from 'react';

import './About.css';

function About() {
  return (
    <div id="content">
      <h1>About Me</h1>
      <span></span>
      <p>
        Hello there! I'm <b>Tom Caspar</b>, a highly motivated software engineer
        with a deep passion for technology and innovation. Armed with a strong
        educational background and hands-on experience in software development,
        I am enthusiastic about solving complex problems through creative and
        efficient solutions.
      </p>
      <h2>Education:</h2>
      <p>
        I hold a{' '}
        <b>
          Bachelor's degree in Engineering (Software) from Swinburne University
          of Technology
        </b>
        , where I gained a comprehensive understanding of computer science
        principles and software development methodologies.
      </p>
      <h2>Skills:</h2>
      <h3>Programming Languages:</h3>
      <p>
        Proficient in languages such as <b>C++, JavaScript, Python and C#</b>, with
        a focus on writing clean, efficient, and well-documented code.
      </p>
      <h3>Web Technologies:</h3>
      <p>
        Knowledgeable in web development technologies including{' '}
        <b>HTML, CSS, JavaScript</b>, and frameworks such as{' '}
        <b>React and Angular</b>.
      </p>
      <h3>Version Control:</h3>
      <p>
        Experienced in using <b>Git and GitHub</b> for collaborative and
        version-controlled software development.
      </p>
      <h3>Problem Solving:</h3>
      <p>
        Adept at analyzing complex problems, designing algorithms, and
        implementing solutions that meet user requirements.
      </p>
      <h3>Software Development Lifecycle:</h3>
      <p>
        Familiar with agile methodologies, continuous integration, and software
        testing practices to deliver high-quality software products.
      </p>
      <h2>Projects:</h2>
      <p>
        During my academic journey, I undertook various projects that honed my
        skills in software engineering. I have developed applications ranging
        from web-based platforms to mobile apps, demonstrating my ability to
        translate ideas into functional, user-friendly software solutions. You
        can find an example of one of these projects by clicking the{' '}
        <b>VISUALISER</b> tab in the header, which will bring you to an
        interactable maze solving algorithm
      </p>
      <h2>Passion and Dedication:</h2>
      <p>
        I am driven by the desire to contribute to the ever-evolving tech
        landscape. I am not just a software engineer; I am a problem solver, an
        innovator, and a lifelong learner. My goal is to leverage my skills and
        knowledge to create impactful software that makes a difference in
        people's lives. I am currently seeking opportunities to collaborate on
        challenging projects, where I can apply my expertise and continue to
        grow as a software engineer.
      </p>
    </div>
  );
}

export default About;
